import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=05ab1bec&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=05ab1bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab1bec",
  null
  
)

export default component.exports